(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageRiaPlanSelection', [
			'$document',
			'$filter',
			'globalConfig',
			'ServiceLevelFactory',
			ManageRiaPlanSelectionFunction
		]);

	function ManageRiaPlanSelectionFunction(
		$document,
		$filter,
		globalConfig,
		ServiceLevelFactory
	) {
		var manageRiaPlanSelection = this;
		var availableRiaPlans;

		function addDescription(riaPlan) {
			if(riaPlan.investmentStrategy === 'SUPPLEMENTAL_INCOME') {
				riaPlan.description = 'Create an attractive, consistent passive income stream.';
			} else if(riaPlan.investmentStrategy === 'BALANCED_INVESTING') {
				riaPlan.description = 'Build wealth confidently with the maximum level of diversification.';
			} else if(riaPlan.investmentStrategy === 'LONG_TERM_GROWTH') {
				riaPlan.description = 'Pursue maximum overall returns over the long term.';
			}
		}

		function initPlanSelection() {
			manageRiaPlanSelection.selectedRiaPlanId = manageRiaPlanSelection.currentRiaPlanId;

			var currentPlan = $filter('filter')(availableRiaPlans, {'id':  manageRiaPlanSelection.currentRiaPlanId}, true)[0];
			manageRiaPlanSelection.currentPlanIsValid = angular.isDefined(currentPlan);

			if (!manageRiaPlanSelection.currentPlanIsValid) {
				var defaultPlan = $filter('filter')(availableRiaPlans, {'investmentStrategy': manageRiaPlanSelection.currentInvestmentStrategy}, true)[0];
				if (angular.isDefined(defaultPlan)) {
					manageRiaPlanSelection.selectedRiaPlanId = defaultPlan.id;
				} else {
					manageRiaPlanSelection.selectedRiaPlanId = availableRiaPlans[0].id;
				}
			}
		}

		function submitForm() {
			$document[0].getElementById('planSelectionForm').submit();
		}

		manageRiaPlanSelection.confirmOrSubmit = function(){
			var submittedPlan = $filter('filter')(availableRiaPlans, {'id': manageRiaPlanSelection.selectedRiaPlanId}, true)[0];

			var submittedIncomeGoal = submittedPlan.investmentStrategy === 'SUPPLEMENTAL_INCOME';
			manageRiaPlanSelection.earningsGoalsWillBeDeleted = angular.isDefined(manageRiaPlanSelection.futureEarningsGoal) && submittedIncomeGoal;

			manageRiaPlanSelection.showK1Acknowledgment = submittedPlan.planType === 'STANDARD_PLUS';

			if(manageRiaPlanSelection.earningsGoalsWillBeDeleted || manageRiaPlanSelection.showK1Acknowledgment) {
				manageRiaPlanSelection.activeModal = 'acknowledgments-modal';
			} else {
				manageRiaPlanSelection.savePlanAndSubmit();
			}
		};

		manageRiaPlanSelection.handleModalClose = function() {
			manageRiaPlanSelection.activeModal = '';
			manageRiaPlanSelection.formSubmitted = false;
		};

		manageRiaPlanSelection.savePlanAndSubmit = function() {
			ServiceLevelFactory.updatePlan(manageRiaPlanSelection.selectedRiaPlanId)
				.then(function() {
					submitForm();
				})
				.catch(function() {
					manageRiaPlanSelection.formSubmitted = false;
					manageRiaPlanSelection.selectedRiaPlanId = manageRiaPlanSelection.currentRiaPlanId;
				});
		};

		manageRiaPlanSelection.$onInit = function() {
			angular.extend(manageRiaPlanSelection, globalConfig);

			ServiceLevelFactory.getAvailableRiaPlans(manageRiaPlanSelection.currentServiceLevel, manageRiaPlanSelection.isIra)
				.then(function(apiAvailableRiaPlans) {
					availableRiaPlans = apiAvailableRiaPlans;

					manageRiaPlanSelection.starterPlan = $filter('filter')(availableRiaPlans, {'planType': 'STARTER'}, true)[0];

					manageRiaPlanSelection.standardPlans = $filter('filter')(availableRiaPlans, {'planType': 'STANDARD'}, true);
					angular.forEach(manageRiaPlanSelection.standardPlans, function(plan) {
						addDescription(plan);
					});

					manageRiaPlanSelection.iraPlans = $filter('filter')(availableRiaPlans, {'planType': 'IRA_ONLY'}, true);
					angular.forEach(manageRiaPlanSelection.iraPlans, function(plan) {
						addDescription(plan);
					});

					manageRiaPlanSelection.plusPlans = $filter('filter')(availableRiaPlans, {'planType': 'STANDARD_PLUS'}, true);

					initPlanSelection();
				});
		};
	}
})(window.angular);